import useSearchRefs from "./hooks/useSearchRefs.js";
import useSearchBarEffects from "./hooks/useSearchBarEffects.js";
import useSearchInput from "./hooks/useSearchInput.js";
import useSearchKeyPress from "./hooks/useSearchKeyPress.js";
import useSearchBarOpen from "./hooks/useSearchBarOpen.js";
import useSearchSelected from "./hooks/useSearchSelected.js";
import useSearchControlledValue from "./hooks/useSearchControlledValue.js";
import { useSearchResultsList } from "./hooks/useSearchResultsList.js";
export const useSearchBar = ({ data, onSubmit, closeOnSubmit, maxResultsAmount, overwriteClick, onSearch, onChange, isPreviousQueriesEnabled, delay, onMoreResultsClick, preloadSearch, }) => {
    const { inputSearchRef, wrapperRef } = useSearchRefs();
    const { selectedIndex, setSelectedIndex, resetSelectedHandler } = useSearchSelected();
    const { searchValue, onChangeHandler, setSearchValue, resetSearchValue } = useSearchControlledValue({
        onSearch,
        delay,
        onChange,
    });
    const { isOpen, close, mobileOpen, mobileClose, toggleHandler, closeDesktopAndMobile, responsiveToggleHandler } = useSearchBarOpen({ overwriteClick, resetSearchValue, preloadSearch });
    const { queries, searchFieldKey, clear, submitHandler, setQuery } = useSearchInput({
        closeOnSubmit,
        onSubmit,
        onClear: closeDesktopAndMobile,
        close,
    });
    const { hasData, hasResults, results } = useSearchResultsList({
        data,
        queries,
        preloadSearch,
        isPreviousQueriesEnabled,
    });
    const { keyDownHandler } = useSearchKeyPress({
        clear,
        close,
        results,
        closeOnSubmit,
        maxResultsAmount,
        resetSelectedHandler,
        selectedIndex,
        setSelectedIndex,
        submitHandler,
        searchValue,
        payload: responsiveToggleHandler,
        escapeDisabled: !isOpen || !!inputSearchRef.current?.value?.trim(),
        resultsLength: results.length ?? 0,
    });
    useSearchBarEffects({
        isOpen,
        mobileOpen,
        searchFieldKey,
        open: isOpen,
        ref: inputSearchRef,
        closeHandler: close,
        mobileCloseHandler: mobileClose,
    });
    const isExpanded = preloadSearch?.isLoading || (isOpen && hasResults);
    return {
        isOpen,
        close,
        clear,
        mobileOpen,
        mobileClose,
        isExpanded,
        results,
        hasData,
        wrapperRef,
        inputSearchRef,
        resultListAnchor: isExpanded ? wrapperRef : null,
        searchFieldKey,
        selectedIndex,
        keyDownHandler,
        searchValue,
        setSearchValue,
        onChangeHandler,
        setCurrentSearchAsQuery: () => setQuery(searchValue),
        toggle: toggleHandler,
        searchOnFocusHandler: resetSelectedHandler,
        moreResultsClickHandler: () => onMoreResultsClick?.(searchValue),
    };
};
export default useSearchBar;
